import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';

@Component({
  selector: 'organization-details-form',
  templateUrl: './organization-details-form.component.html',
  styleUrls: ['./organization-details-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationDetailsFormComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isEditView: boolean;

  public CUSTOM_MASK: any = CUSTOM_MASK;

  constructor() {}

  ngOnInit() {}
}
